export enum EnumParameterType {
  driverFee = 'Comissão Motorista',
  taxiDriverDiscountCard = 'Desconto Acerto Taxista Cartão',
  taxiDriverDiscountCovenant = 'Desconto Acerto Taxista Convênio',
  taxiDriverCommission = 'Comissão Acerto Taxista',
}
